module.exports = __webpack_public_path__ + "public/media/akl-mama.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/akl-mama.png
// module id = ./images/partners/akl-mama.png
// module chunks = 0